import React, { useEffect, useRef } from "react";
import { Dialog, DialogContent } from "./dialog";
import gsap from "gsap";

const SuccessModal = ({ isOpen, onClose, title, message }) => {
  const checkRef = useRef(null);
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen && checkRef.current && modalRef.current) {
      // Reset animation
      gsap.set(checkRef.current, { 
        scale: 0, 
        rotation: -180, 
        opacity: 0 
      });
      gsap.set(modalRef.current, { 
        scale: 0.8, 
        opacity: 0 
      });

      // Animate modal entrance
      const tl = gsap.timeline();
      
      tl.to(modalRef.current, {
        scale: 1,
        opacity: 1,
        duration: 0.3,
        ease: "back.out(1.7)"
      })
      .to(checkRef.current, {
        scale: 1,
        rotation: 0,
        opacity: 1,
        duration: 0.6,
        ease: "back.out(2)",
      }, "-=0.1")
      .to(checkRef.current, {
        scale: 1.1,
        duration: 0.2,
        ease: "power2.out",
        yoyo: true,
        repeat: 1
      }, "-=0.2");

      // Auto close after 3 seconds
      const timer = setTimeout(() => {
        onClose();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent 
        ref={modalRef}
        className="sm:max-w-md mx-auto bg-white dark:bg-neutral-900 border-0 shadow-2xl"
        hideCloseButton
      >
        <div className="flex flex-col items-center justify-center p-6 text-center">
          {/* Animated Check Icon */}
          <div 
            ref={checkRef}
            className="w-16 h-16 mb-4 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center"
          >
            <svg 
              className="w-8 h-8 text-green-600 dark:text-green-400" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={3} 
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>

          {/* Title */}
          <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100 mb-2">
            {title || "Nachricht gesendet"}
          </h3>

          {/* Message */}
          <p className="text-sm text-neutral-600 dark:text-neutral-400 leading-relaxed">
            {message || "Vielen Dank für Ihre Anfrage. Ich melde mich zeitnah bei Ihnen zurück."}
          </p>

          {/* Auto-close indicator */}
          <div className="mt-4 text-xs text-neutral-500 dark:text-neutral-500">
            Schließt automatisch in wenigen Sekunden
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export { SuccessModal };
